// app/src/config.ts

// Tomamos la base de API de sessionStorage si existe, si no usamos la oficial
const DEFAULT_API_BASE =
  typeof window !== 'undefined' && window.location.hostname.includes('fransdata.com')
    ? 'https://api.humanperformcenter.com'
    : 'https://api.humanperformcenter.com';

const apiBaseFromSession =
  typeof window !== 'undefined' ? sessionStorage.getItem('API_BASE') : null;

const apiBaseFromEnv = import.meta.env.VITE_API_BASE || null;

export const API_BASE = apiBaseFromSession || apiBaseFromEnv || DEFAULT_API_BASE;
export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID || '';

// Endpoints de auth
export const LOGIN_ENDPOINT = '/api/mobile/login';
export const REGISTER_ENDPOINT = '/api/mobile/register';

const config = {
  API_BASE,
  LOGIN_ENDPOINT,
  REGISTER_ENDPOINT,
  GOOGLE_CLIENT_ID,
};

export default config;
